module.exports = __webpack_public_path__ + "static/habitica-77927f620ebf6123eda5ba6c236755ef.svg";